import { BaseDocVerifierManager } from '../../../core/managers/doc-verifier-manager.base';
import type { ModalReturnType, PasswordModalProps, PasswordParam } from '@tencent/docs-crypto-kit';

export class MobileDocVerifierManager extends BaseDocVerifierManager {
    protected async showPasswordModal(props: PasswordModalProps): Promise<ModalReturnType> {
        const { showPasswordModalMobile } = await this.getCryptoKit();
        return showPasswordModalMobile(props);
    }

    protected async validateDocumentPassword(param: PasswordParam): Promise<ModalReturnType> {
        const { validateDocumentPasswordMobile } = await this.getCryptoKit();
        return validateDocumentPasswordMobile(param);
    }

    protected getOpenVerifierConfig(): PasswordModalProps {
        return {
            onCancel: () => {
                // 关闭移动端标签
                this.mqq.invoke('ui', 'popBack');
            },
        };
    }

    protected getModifyVerifierConfig(): PasswordParam {
        return {
            onSuccess: () => {
                this.switchDocReadOnly(false);
            },
        };
    }
}
